import React from 'react';
import { BaseSegmentControl } from './base-control';
import styles from './segment-control.module.scss';
export const SegmentControl = (props) => {
    const { classNames } = props;
    const { segmentedControl, disabled, selectedHighlight } = styles;
    return (React.createElement(BaseSegmentControl, { ...props, classNames: {
            segmentedControl,
            disabled,
            selectedHighlight,
            ...classNames,
        }, type: "SegmentControl" }));
};
//# sourceMappingURL=segment-control.js.map